export { default as CategoriesIndexPageSubHeader } from './CategoriesIndexPageSubHeader';
